import { setNavigate } from "@/router/navigation";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const NavigationProvider = () => {
  const navigate = useNavigate();

  useEffect(() => {
    setNavigate(navigate);
  }, [navigate]);

  return null; // ничего не рендерим
};
